//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('custGrpMenu', {
//        templateUrl: 'views/components/views/custGrpMenu/custGrpMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'custGrpMenuService', function ($stateParams, stateService, translateService, modalService, custGrpMenuService) {
//            const vm = this;
//            let custGrpId = $stateParams.custgrp_id;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                customerGroupNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('custgrplangs', { custgrp_id: vm.model.menu.custgrp_id }) }
//                ],
//                menu: {},
//                lockedDelete: false
//            };

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            async function loadMenu() {
//                vm.model.menu = (await custGrpMenuService.getMenu({ custgrp_id: custGrpId }))[0];
//            }

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    custGrpMenuService.deleteItem(vm.model.menu).then(() => {
//                        vm.model.lockedDelete = false;
//                        stateService.back();
//                    }, () => {
//                        vm.model.lockedDelete = false;
//                    });
//                }, () => {
//                    vm.model.lockedDelete = false;
//                });
//            };

//            vm.$onInit = function () {
//                translate();
//                loadMenu();
//            };
//        }]
//    });
//})();
